"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNotFoundPhotograph = exports.StyledPowerText = exports.StyledNotFoundInfo = exports.StyledNotFoundTitle = exports.StyledNotFoundBackground = exports.StyledNotFoundWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var _MediaQueries = _interopRequireDefault(require("../../../MediaQueries"));

var _templateObject, _templateObject2;

var StyledNotFoundWrapper = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledNotFoundWrapper",
  componentId: "ewhj9f-0"
})(["position:fixed;width:100vw;height:100vh;top:0;left:0;"]);
exports.StyledNotFoundWrapper = StyledNotFoundWrapper;

var StyledNotFoundBackground = _styledComponents["default"].img.withConfig({
  displayName: "Elements__StyledNotFoundBackground",
  componentId: "ewhj9f-1"
})(["width:100%;height:100%;object-fit:cover;"]);

exports.StyledNotFoundBackground = StyledNotFoundBackground;

var StyledNotFoundTitle = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledNotFoundTitle",
  componentId: "ewhj9f-2"
})(["font-family:Helvetica,sans-serif;font-style:normal;font-weight:bold;font-size:80px;line-height:80px;color:", ";"], function (props) {
  return props.theme.veryDarkGrey;
});

exports.StyledNotFoundTitle = StyledNotFoundTitle;
var StyledNotFoundInfo = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledNotFoundInfo",
  componentId: "ewhj9f-3"
})(["position:absolute;top:50%;left:64px;width:385px;margin-top:-108px;", ""], _MediaQueries["default"].maxWidth.small(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    width: 300px;\n    left: 16px;\n  "]))));
exports.StyledNotFoundInfo = StyledNotFoundInfo;

var StyledPowerText = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledPowerText",
  componentId: "ewhj9f-4"
})(["font-family:Helvetica,sans-serif;font-style:normal;font-weight:normal;font-size:16px;line-height:16px;color:", ";a{color:", ";text-decoration:underline;}"], function (props) {
  return props.theme.veryDarkGrey;
}, function (props) {
  return props.theme.veryDarkGrey;
});

exports.StyledPowerText = StyledPowerText;

var StyledNotFoundPhotograph = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledNotFoundPhotograph",
  componentId: "ewhj9f-5"
})(["position:absolute;right:64px;bottom:24px;font-family:Helvetica,sans-serif;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;color:", ";", ""], function (props) {
  return props.theme.veryDarkGrey;
}, _MediaQueries["default"].maxWidth.small(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    right: 16px;\n    bottom: 16px;\n  "]))));

exports.StyledNotFoundPhotograph = StyledNotFoundPhotograph;